export const COMMON_UPDATE_ESTIMATED_VS_GA_TOGGLE = "COMMON_UPDATE_ESTIMATED_VS_GA_TOGGLE";
export const COMMON_SW_SETTINGS_READY = "COMMON_SW_SETTINGS_READY";
export const ESTIMATIONS_VS_GA_USER_PREFRENCES_UPDATE_SUCCESS = "ESTIMATIONS_VS_GA_USER_PREFRENCES_UPDATE_SUCCESS";
export const ESTIMATIONS_VS_GA_USER_PREFRENCES_UPDATE_FAILURE = "ESTIMATIONS_VS_GA_USER_PREFRENCES_UPDATE_FAILURE";
export const UNSUPPORTED_WEBSOURCE_REDIRECT = "UNSUPPORTED_WEBSOURCE_REDIRECT";
export const HIDE_WEBSOURCE_TOOLTIP = "HIDE_WEBSOURCE_TOOLTIP";
export const USER_DID_COMPARE = "USER_DID_COMPARE";
export const USER_DID_NOT_COMPARE = "USER_DID_NOT_COMPARE";
export const UNSUPPORTED_COUNTRY_REDIRECT = "UNSUPPORTED_COUNTRY_REDIRECT";
export const HIDE_COUNTRY_TOOLTIP = "HIDE_COUNTRY_TOOLTIP";
export const PAGE_NOTIFICATION_BAR_ITEM_GENERATED = "PAGE_NOTIFICATION_BAR_ITEM_GENERATED";
export const PAGE_NOTIFICATION_BAR_ITEM_REMOVED = "PAGE_NOTIFICATION_BAR_ITEM_REMOVED";
export const NOTIFICATION_BAR_ITEM_GENERATED = "NOTIFICATION_BAR_ITEM_GENERATED";
export const NOTIFICATION_BAR_ITEM_REMOVED = "NOTIFICATION_BAR_ITEM_REMOVED";
export const NOTIFICATION_BAR_UPDATE_HEIGHT = "NOTIFICATION_BAR_UPDATE_HEIGHT";
export const NOTIFICATION_BUBBLE_OPEN = "NOTIFICATION_BUBBLE_OPEN";
export const NOTIFICATION_BUBBLE_REMOVE = "NOTIFICATION_BUBBLE_REMOVE";
export const CREATE_USERMANAGEMENT_LINK = "CREATE_USERMANAGEMENT_LINK";
export const REMOVE_USERMANAGEMENT_LINK = "REMOVE_USERMANAGEMENT_LINK";
export const STATE_COMPARE_STATUS = "STATE_COMPARE_STATUS";
export const ALL_STATES_COMPARE_STATUS = "ALL_STATES_COMPARE_STATUS";
export const SHOW_TOP_NAV = "SHOW_TOP_NAV";
export const HIDE_TOP_NAV = "HIDE_TOP_NAV";
export const EMPTY_TOP_BAR = "EMPTY_TOP_BAR";
export const POPULATE_TOP_BAR = "POPULATE_TOP_BAR";
export const TOGGLE_RESET_BETA_VS_LIVE_MODAL = "TOGGLE_RESET_BETA_VS_LIVE_MODAL";
export const COMMON_UPDATE_BETA_VS_LIVE_TOGGLE = "COMMON_UPDATE_BETA_VS_LIVE_TOGGLE";
export const COMMON_UPDATE_BETA_VS_LIVE_TOGGLE_CCOMPLETED = "COMMON_UPDATE_BETA_VS_LIVE_TOGGLE_CCOMPLETED";
export const COMMON_RESET_BETA_VS_LIVE_TOGGLE = "COMMON_RESET_BETA_VS_LIVE_TOGGLE";
export const TOGGLE_ALTERNATIVE_SOURCE = "TOGGLE_ALTERNATIVE_SOURCE";
